module.exports = __webpack_public_path__ + "img/Container02.7d5eaf80.jpg";